import React from 'react';

const MolaturaReportsTable = ({children, action = undefined}) => {

  return (
    <div className='table-responsive'>
      <table className='table table-hover align-middle'>
        <thead>
        <tr>
          <th className='text-end'>Controllo</th>
          <th className='text-center'>Dimensionale</th>
          <th className='text-center'>Imperfezioni profilo molatura</th>
          <th className='text-center'>Visivo</th>
        </tr>
        <tr>
          <th className='text-end'>Tolleranza</th>
          <th className='text-center'>+0mm/-1mm</th>
          <th className='text-center'></th>
          <th className='text-center'></th>
        </tr>
        </thead>
        <tbody>
        {children}
        </tbody>
        {action}
      </table>
    </div>
  )

}

export default MolaturaReportsTable
